export function setNotifications (state, notifications) {
  state.notifications = notifications
}
